'use client'

import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { gaLogIn } from '@/utils/gtag'
import { useSession } from 'next-auth/react'
import { useEffect } from 'react'

export function useSignUpEvent() {
  const domainUrl = useFullDomainUrl()
  const { data: session, update } = useSession()

  useEffect(() => {
    if (session?.isSignUp) {
      const pushEvent = async () => {
        gaLogIn({
          method: session.user.account.provider as 'google' | 'kakao',
          pageUrl: domainUrl,
          isSignUp: false,
        })

        await update({})
      }

      void pushEvent()
    }
  }, [session, domainUrl, update]) // 필요한 종속성 추가
}
